// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3k3bx","tab":"ProcedureTabs_tab__16ZJs"};